<template>
    <div id="members">
        <status-message></status-message>
        <generic-pager :currentCount="members.length" :count="membersCount" :pageCount="pageCount" :lastObject="lastPagerObject" @update-list="updateList" :reset="resetList" :loading="isLoading">

            <div class="td-table-container mt-0" v-if="members && members.length > 0">
                <table cellspacing="0" cellpadding="0" class="td-table">
                    <thead>
                        <tr class="table-header">
                            <th>Name</th>
                            <th>Status</th>
                            <th>Type</th>
                            <th>Modified</th>
                            <th>Phone #</th>
                            <th>City/State</th>
                            <th class="td-text-right"></th>
                        </tr>
                    </thead>
                    <tbody v-if="!isLoading && members.length > 0" v-for="(member, index) in members" :key="member.id" class="rows-container">
                        <tr class="table-row main-row">
                            <td class="name">
                                <a @click="goToAccount(member)" style="text-decoration: none;">
                                    <h2 class="td-h5 mt-0">
                                        {{ member.ain }} - {{ member.n }}
                                    </h2>
                                </a>
                            </td>
                            <td class="status">
                                {{ getStatus(member.status)}}
                            </td>
                            <td class="type">
                                {{ getType(member.accountType) }}
                            </td>
                            <td class="modified">
                                {{ dateDisplay(member.modifiedDate) }}
                            </td>
                            <td class="office-number">
                                {{ formatPhoneString(member.info.officeNumber) }}
                            </td>
                            <td class="city-state">
                                {{ getAddress(member) }}
                            </td>

                            <td>
                                <a :href="'/accounts/admin/' + member.ain" class="td-btn secondary-outlined slim" title="View" @click.prevent="goToAccount(member)">
                                    View
                                </a>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-if="isLoading">
                        <tr><th colspan="5"><div class="loading loading-table"><icon name="faSpinner" type="solid" spin></icon></div></th></tr>
                    </tbody>
                </table>

            </div>
        </generic-pager>
    </div>
    <div v-if="members && members.length < 1 && !isLoading" class="td-banner warning no-icon mt-2">
        <p>No member accounts found.</p>
    </div>
</template>

<script>
    import script from './Members';
    export default script;
</script>

<style lang="less">
    @import './Members.less';
</style>